
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    ActionGroup,
    ActionGroupItemModifier,
    ActionGroupModifier,
    ActionGroupStyle,
    ActionItem,
    ActionItemStyle,
    IconSize,
    ShActionGroupComponent
} from '../../../../../../elements/public_api';
import { DisplayMode } from '../../entities/display-mode.entity';

@Component({
    standalone: true,
    selector: 'sh-view-toggle',
    templateUrl: './view-toggle.component.html',
    imports: [ShActionGroupComponent]
})
export class ShViewToggleComponent {
    private displayModeOptions: DisplayMode[] = [];
    private mode: DisplayMode;

    public toggleActionGroup: ActionGroup | undefined;
    public showActionGroup: boolean;
    public childComponentClasses?: string[] = ['sh-action-group__item__action'];
    @Input() set displayMode(displayMode: DisplayMode | null) {
        if (displayMode !== null) {
            this.mode = displayMode;
            this.toggleActionGroup = this.getToggleActionGroup(displayMode);
            this.showActionGroup = this.toggleActionGroup.actions.length > 0;
        } else {
            this.toggleActionGroup = undefined;
            this.showActionGroup = false;
        }
    }

    @Input() set displayOptions(displayOptions: DisplayMode[]) {
        this.displayModeOptions = displayOptions;
        if (!!this.mode) {
            this.toggleActionGroup = this.getToggleActionGroup(this.mode);
            this.showActionGroup = this.toggleActionGroup.actions.length > 0;
        }
    }

    @Output() displayModeChanged: EventEmitter<DisplayMode> = new EventEmitter<DisplayMode>();

    private getToggleActionGroup(displayMode: DisplayMode): ActionGroup {
        return {
            actions: this.getToggleActionItems(displayMode),
            modifiers: [ActionGroupModifier.End],
            itemModifiers: [ActionGroupItemModifier.ClearRightMargin],
            style: ActionGroupStyle.Collapsed
        };
    }

    private getToggleActionItems(displayMode: DisplayMode): ActionItem[] {
        const actionItems: ActionItem[] = [];

        const listViewActionitem: ActionItem = {
            label: '',
            eventListener: this.onListViewSelected.bind(this),
            icon: 'th-list',
            iconSize: IconSize.SMALL,
            style:
                displayMode === DisplayMode.LIST
                    ? ActionItemStyle.PureSquareIconButtonInverted
                    : ActionItemStyle.PureSquareIconButtonLight
        };

        const gridViewActionitem: ActionItem = {
            label: '',
            eventListener: this.onGridViewSelected.bind(this),
            icon: 'th-large',
            iconSize: IconSize.SMALL,
            style:
                displayMode === DisplayMode.GRID
                    ? ActionItemStyle.PureSquareIconButtonInverted
                    : ActionItemStyle.PureSquareIconButtonLight
        };

        const mapViewActionitem: ActionItem = {
            label: '',
            eventListener: this.onMapViewSelected.bind(this),
            icon: 'map-marked',
            iconSize: IconSize.SMALL,
            style:
                displayMode === DisplayMode.MAP
                    ? ActionItemStyle.PureSquareIconButtonInverted
                    : ActionItemStyle.PureSquareIconButtonLight
        };

        if (this.displayModeOptions.includes(DisplayMode.LIST)) {
            actionItems.push(listViewActionitem);
        }
        if (this.displayModeOptions.includes(DisplayMode.GRID)) {
            actionItems.push(gridViewActionitem);
        }
        if (this.displayModeOptions.includes(DisplayMode.MAP)) {
            actionItems.push(mapViewActionitem);
        }

        return actionItems;
    }

    private onGridViewSelected(): void {
        this.displayModeChanged.emit(DisplayMode.GRID);
    }

    private onListViewSelected(): void {
        this.displayModeChanged.emit(DisplayMode.LIST);
    }

    private onMapViewSelected(): void {
        this.displayModeChanged.emit(DisplayMode.MAP);
    }
}
